import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'bt-auto-complate-client',
  templateUrl: './auto-complate-client.component.html',
  styleUrls: ['./auto-complate-client.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoComplateClientComponent implements OnInit, OnChanges {

  @Input() options: any[];
  @Input() config;
  @Input() touched = false;
  @Input() initial;
  @Input() required = true;
  @Input() disabled: boolean;
  @Output() selectedOption = new EventEmitter<any>();

  myControl = new FormControl();
  filteredOptions: Observable<any[]>;


  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {

  }

  ngOnInit() {


  }
  ngOnChanges() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name) : this.options?.slice())
      );

    if (this.initial || this.initial === '') {
      this.myControl.setValue(this.initial);
    }
    if (this.disabled) {
      this.myControl.disable();
    }
    if (this.touched) {

      this.myControl.markAsTouched();
    }
    this.changeDetectorRef.detectChanges();
  }

  displayFn(option: any): string {
    return option && option.name ? option.name : '';
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  optionSelected(option) {
    this.selectedOption.emit(option);
  }
  clear() {
    this.myControl.setValue('');
    this.selectedOption.emit('');
  }
}
